import { DropdownStyled } from 'src/components';

import { AMAZON_REGIONS } from '../constants';

interface Props {
  value: string;
  onChange: (queryName: string) => void;
  disabled?: boolean;
}

// Custom styled Amazon-region dropdown, matching VendorSelect.
export const RegionSelect = ({ value, onChange, disabled }: Props) => {
  const selected = AMAZON_REGIONS.find((r) => r.queryName === value) ?? AMAZON_REGIONS[0];

  return (
    <div className='relative w-[180px] shrink-0'>
      <DropdownStyled
        darkStyle={false}
        disabled={disabled}
        className={`w-full ${disabled ? 'opacity-50' : ''}`}
        buttonContent={
          <span className='font-secondary font-semibold text-base text-primary-dark'>
            {selected.displayName}
          </span>
        }
      >
        {(closeDropdown) => (
          <div
            role='listbox'
            aria-label='Select region'
            className='w-[180px] max-h-[215px] overflow-y-auto py-1 bg-cloudGray rounded-lg'
          >
            {AMAZON_REGIONS.map((r) => (
              <div
                key={r.queryName}
                role='option'
                aria-selected={r.queryName === value}
                onClick={() => {
                  onChange(r.queryName);
                  closeDropdown();
                }}
                className='px-3 py-2 cursor-pointer hover:bg-primary/10 font-secondary text-base text-primary'
              >
                {r.displayName}
              </div>
            ))}
          </div>
        )}
      </DropdownStyled>
    </div>
  );
};
